// extracted by mini-css-extract-plugin
module.exports = {"root":"Banner-module--root--14DvL","container":"Banner-module--container--2i2kF","banner":"Banner-module--banner--23A3d","mock":"Banner-module--mock--2fNbS"};